import Container from '@/components/layout/Container';
import CollectionsShowcaseClient from './CollectionsShowcaseClient';

export default async function CollectionsShowcase({ block, position }) {
  const {
    uid,
    background_color_picker,
    discount_badge_background_color_picker,
    discount_badge_text_color_picker,
    secondary_badge_background_color_picker,
    secondary_badge_text_color_picker,
    collections
  } = block.collections_showcase.reference[0];

  const discount_badge = {
    background_color: discount_badge_background_color_picker,
    text_color: discount_badge_text_color_picker
  };
  const secondary_badge = {
    background_color: secondary_badge_background_color_picker,
    text_color: secondary_badge_text_color_picker
  };

  return (
    <section
      id={`${uid}_${position}`}
      data-name="collections-showcase"
      className={`py-15 lg:py-20 bg-[${background_color_picker}]`}
    >
      <Container fullpage={true}>
        <div className="px-1 sm:flex sm:px-0">
          <CollectionsShowcaseClient
            discount_badge={discount_badge}
            secondary_badge={secondary_badge}
            collections={collections}
          />
        </div>
      </Container>
    </section>
  );
}
